<span *ngIf="editable; else staticDate">
    <a (click)="picker.open()" mat-stroked-button [matTooltip]="startDate ? 'Startdatum ändern' : 'Startdatum festlegen'">{{ startDate | date | unset }}</a>
</span>
<ng-template #staticDate>{{ startDate | date }}</ng-template>

<input matInput [matDatepicker]="picker" [value]="startDate">
<mat-datepicker #picker></mat-datepicker>
